export const whereIsThisConstant = {
    WHERE_IS_tHIS_CHANGE: 'WHERE_IS_tHIS_CHANGE',
    SELECTED_OBJECT_TYPE: 'SELECTED_OBJECT_TYPE',
    SELECTED_CATEGORIES: 'SELECTED_CATEGORIES',
    GET_USE_ISFEEDBACK: 'GET_USE_ISFEEDBACK',
    SET_SELECTED_FEATURES: 'SET_SELECTED_FEATURES',
    SELECTED_ADDRESS_DATA: 'SELECTED_ADDRESS_DATA',
    SHOW_IS_LOADING: 'SHOW_IS_LOADING',
    RELOAD_CUSTOMER_TABLE: 'RELOAD_CUSTOMER_TABLE',
    RELOAD_TREE_STRUCTURE: 'RELOAD_TREE_STRUCTURE',
    SET_DRAWOPEN: 'SET_DRAWOPEN',
};

export default whereIsThisConstant;